export type SystemAppIds = { task: string | null; issue: string | null };

export function setActiveColor(name: string, { task, issue }: SystemAppIds) {
  const path = globalThis.location.pathname.split('/');

  // conditional to separate form/Apps path from system apps
  const formID = (pathname: string[]) => {
    const isForm = pathname[1] === 'apps' || pathname[1] === 'dash';

    if (isForm && (pathname[2] !== task && pathname[2] !== issue)) {
      return pathname[2];
    }

    return '';
  };

  const routes: Record<string, string[]> = {
    Apps: ['^/apps', `^/apps/${formID(path)}`, `^/dash/${formID(path)}`],
    Dashboard: ['^/$', '^/home'],
    Tasks: ['^/tasks', ...(task ? [`^/dash/${task}`] : [])],
    Issues: ['^/issues', ...(issue ? [`^/dash/${issue}`] : [])],
    Insights: ['^/insights'],
    Boards: ['^/boards', '^/infographics'],
    Groups: ['^/groups'],
    Imports: ['^/imports'],
    Exports: ['^/exports'],
    Projects: ['^/projects'],
    'Map Layers': ['^/layers'],
    'Choice Lists': ['^/choice_lists'],
    'Classification Sets': ['^/classification_sets'],
    'Member Profile': ['^/settings/profile'],
    'Organization Profile': ['^/settings/organization'],
    Billing: ['^/settings/subscription', '^/settings/plans', '^/settings/upgrades', '^/settings/billing'],
    Members: ['^/settings/members'],
    Roles: ['^/settings/roles'],
    API: ['^/settings/api'],
    Webhooks: ['^/settings/webhooks'],
    'Audit Logs': ['^/settings/audit_logs'],
    'Early Access Features': ['^/settings/early_access_features'],
  };

  const pathPatterns = routes[name] || [];

  if (pathPatterns.some((pathRegex) => new RegExp(pathRegex).test(globalThis.location.pathname))) {
    return { color: '#eb1300', backgroundColor: '#fff' };
  }

  return undefined;
}
